import { useState, useEffect } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom";
import useExternalAuth from "../../hooks/useExternalAuth";
import { AcceptableProviders } from "../../@types/Auth";
import ErrorModal from "../../components/shared/ErrorModal";

export default function AuthCallback() {
  const [isFailed, setIsFailed] = useState<boolean>(false);

  const { handleCallbackAuth } = useExternalAuth();
  const query = useLocation().search;
  const { push } = useHistory();

  function getProviderName(): AcceptableProviders | null {
    if (query.includes("www.googleapis.com")) {
      return "google";
    }

    return null;
  }

  useEffect(() => {
    async function determineCanContinue() {
      const provider = getProviderName();

      if (provider) {
        const isAuthenticated = await handleCallbackAuth(provider, query);

        if (isAuthenticated) {
          push("/welcome");
        } else {
          setIsFailed(true);
        }
      } else {
        setIsFailed(true);
      }
    }

    determineCanContinue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isFailed) {
    return (
      <ErrorModal
        title="Oops!"
        description="Ocorreu um erro não esperado ao validar sua autenticação, por favor, tente novamente."
        action={{
          title: "Tentar novamente",
          url: "/login",
        }}
      />
    );
  }

  return (
    <Modal fullscreen size="lg" show>
      <div className="centered-flex pd-40">
        <Spinner animation="border" />
      </div>
    </Modal>
  );
}
